import React, { useState } from "react";
import { Menu, MenuItem } from "@material-ui/core";

const MobileAppStoreMenu = ({ options, children }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const availableOptions = (options || []).filter((option) => option.url);

  const openStore = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
    setAnchorEl(null);
  };

  const handleClick = (event) => {
    event.preventDefault();

    if (availableOptions.length === 1) {
      openStore(availableOptions[0].url);
      return;
    }

    setAnchorEl(event.currentTarget);
  };

  return (
    <>
      {React.cloneElement(children, { onClick: handleClick })}
      {availableOptions.length > 1 && (
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
          getContentAnchorEl={null}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
        >
          {availableOptions.map((app) => (
            <MenuItem key={app.label} onClick={() => openStore(app.url)}>
              {app.label}
            </MenuItem>
          ))}
        </Menu>
      )}
    </>
  );
};

export default MobileAppStoreMenu;
